import type { TColor } from '@Theme';
import type { FC } from 'react';
import React from 'react';
import { Platform } from 'react-native';
import { Switch as PaperSwitch } from 'react-native-paper';
import styledWeb, { css } from 'styled-components';
import styledNative from 'styled-components/native';

import OwnableTheme from '../../assets/OwnableTheme';

const styled = Platform.OS === 'web' ? styledWeb : styledNative;
const StyledPaperSwitch: typeof PaperSwitch = styled(PaperSwitch as any)<{
  value: boolean;
}>`
  ${({ value }) =>
    Platform.OS === 'web' &&
    css`
      div:first-child {
        background: ${value
          ? `${OwnableTheme.colors.amaranth} !important`
          : 'transparent !important'};
        ${!value &&
        css`
          border: 1px ${OwnableTheme.colors.persianIndigo} solid;
        `}
      }
      div:nth-child(2) {
        background: ${value
          ? 'white !important'
          : `${OwnableTheme.colors.persianIndigo} !important`};
      }
    `}
`;

type ISwitchProps = {
  isSwitchOn: boolean;
  onChange: (currentState: boolean) => void;
  color?: TColor;
};

export const Switch: FC<ISwitchProps> = ({ isSwitchOn, onChange, color }) => (
  <StyledPaperSwitch
    color={color ?? OwnableTheme.colors.amaranth}
    value={isSwitchOn}
    onValueChange={(value) => {
      onChange(value);
    }}
  />
);
